/*
  Mast: disable "Select Store" for stores where the selected product/variant
  is not available (red X in the store selector drawer).
  Added Nov 2026. Wraps the store-selector element's addLocation() so the
  original theme bundle (theme-j3UWO_3g.js) stays untouched.
*/
(function () {
  function patch(StoreSelector) {
    if (!StoreSelector || StoreSelector.prototype.__mastAvailabilityPatch) return;
    var original = StoreSelector.prototype.addLocation;
    if (typeof original !== 'function') return;

    StoreSelector.prototype.addLocation = function (location, selected, productData) {
      var result = original.apply(this, arguments);
      try {
        // The original skips warehouse locations without adding a card.
        if (!location || (location.name || '').indexOf('Warehouse') >= 0) return result;
        // No product context, or availability hidden for this product: leave as-is.
        if (!productData || productData.shouldHideAvailability) return result;
        // The currently selected store keeps its "Selected" state.
        if (selected && selected.id === location.id) return result;

        var node = productData.nodes && productData.nodes[0];
        var match = node && node.storeAvailability && node.storeAvailability.nodes
          ? node.storeAvailability.nodes.find(function (n) { return n.location.id === location.id; })
          : null;
        if (match && match.available) return result;

        var card = this.locationsList && this.locationsList.lastElementChild;
        var button = card && card.querySelector('[data-store-selector-store-select]');
        if (!button) return result;

        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        // Theme's disabled look is a light background; keep it but use darker
        // text so the label meets 4.5:1 contrast (#5C5B57 on #F6F6F2 = 6.3:1).
        button.style.opacity = '1';
        button.style.backgroundColor = '#F6F6F2';
        button.style.color = '#5C5B57';
        button.style.cursor = 'not-allowed';
        button.textContent = (window.storeSelector && window.storeSelector.isUnavailable) || 'Not Available';
      } catch (err) {
        if (window.console) console.warn('store-selector-availability:', err);
      }
      return result;
    };
    StoreSelector.prototype.__mastAvailabilityPatch = true;
  }

  if (window.customElements) {
    var existing = customElements.get('store-selector');
    if (existing) patch(existing);
    else customElements.whenDefined('store-selector').then(function () {
      patch(customElements.get('store-selector'));
    });
  }
})();
